import type { Template } from "@/types";

export const SQ_07_H3_V4: Template[] = [
    {
        id: "sq-07-h3v4-01",
        name: "SQ 01 - H3V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h3_v4_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 50, y: 45, width: 617, height: 406, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 459, width: 305, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 459, width: 304, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 847, y: 45, width: 224, height: 309, rotation: 0, imageRotation: 0 },
            { id: "5", x: 847, y: 362, width: 224, height: 309, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1079, y: 45, width: 224, height: 309, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1079, y: 362, width: 224, height: 309, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h3v4-02",
        name: "SQ 02 - H3V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h3_v4_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 75, y: 87, width: 222, height: 176, rotation: 0, imageRotation: 0 },
            { id: "2", x: 75, y: 271, width: 222, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 75, y: 455, width: 222, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 305, y: 87, width: 337, height: 545, rotation: 0, imageRotation: 0 },
            { id: "5", x: 792, y: 87, width: 375, height: 545, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1175, y: 87, width: 184, height: 268, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1175, y: 363, width: 184, height: 268, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h3v4-03",
        name: "SQ 03 - H3V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h3_v4_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 50, y: 45, width: 617, height: 406, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 459, width: 305, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 459, width: 304, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 767, y: 46, width: 461, height: 626, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1236, y: 46, width: 148, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1236, y: 258, width: 148, height: 203, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1236, y: 469, width: 148, height: 203, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h3v4-04",
        name: "SQ 04 - H3V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h3_v4_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 50, y: 154, width: 192, height: 131, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 293, width: 192, height: 131, rotation: 0, imageRotation: 0 },
            { id: "3", x: 50, y: 432, width: 192, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 250, y: 154, width: 267, height: 409, rotation: 0, imageRotation: 0 },
            { id: "5", x: 845, y: 46, width: 461, height: 626, rotation: 0, imageRotation: 0 },
            { id: "6", x: 525, y: 154, width: 142, height: 201, rotation: 0, imageRotation: 0 },
            { id: "7", x: 525, y: 363, width: 142, height: 200, rotation: 0, imageRotation: 0 }
        ],
    },
   
    {
        id: "sq-07-h3v4-05",
        name: "SQ 05 - H3V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h3_v4_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 149, y: 44, width: 206, height: 144, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 44, width: 206, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 149, y: 196, width: 420, height: 282, rotation: 0, imageRotation: 0 },
            { id: "4", x: 149, y: 486, width: 135, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 292, y: 486, width: 135, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 435, y: 486, width: 134, height: 188, rotation: 0, imageRotation: 0 },
            { id: "7", x: 866, y: 44, width: 420, height: 630, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h3v4-06",
        name: "SQ 06 - H3V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h3_v4_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 149, y: 44, width: 420, height: 282, rotation: 0, imageRotation: 0 },
            { id: "2", x: 149, y: 333, width: 206, height: 145, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 333, width: 206, height: 145, rotation: 0, imageRotation: 0 },
            { id: "4", x: 149, y: 486, width: 135, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 292, y: 486, width: 135, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 435, y: 486, width: 134, height: 188, rotation: 0, imageRotation: 0 },
            { id: "7", x: 866, y: 44, width: 420, height: 630, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h3v4-07",
        name: "SQ 07 - H3V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h3_v4_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 149, y: 44, width: 206, height: 311, rotation: 0, imageRotation: 0 },
            { id: "2", x: 149, y: 363, width: 206, height: 310, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 44, width: 205, height: 311, rotation: 0, imageRotation: 0 },
            { id: "4", x: 363, y: 363, width: 205, height: 310, rotation: 0, imageRotation: 0 },
            { id: "5", x: 922, y: 44, width: 308, height: 205, rotation: 0, imageRotation: 0 },
            { id: "6", x: 922, y: 257, width: 308, height: 205, rotation: 0, imageRotation: 0 },
            { id: "7", x: 922, y: 470, width: 308, height: 204, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h3v4-08",
        name: "SQ 08 - H3V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h3_v4_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 110, width: 713, height: 498, rotation: 0, imageRotation: 0 },
            { id: "2", x: 721, y: 110, width: 353, height: 229, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1082, y: 110, width: 352, height: 229, rotation: 0, imageRotation: 0 },
            { id: "4", x: 721, y: 346, width: 173, height: 261, rotation: 0, imageRotation: 0 },
            { id: "5", x: 902, y: 346, width: 172, height: 261, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1082, y: 346, width: 172, height: 261, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1262, y: 346, width: 172, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h3v4-09",
        name: "SQ 09 - H3V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h3_v4_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 136, width: 297, height: 446, rotation: 0, imageRotation: 0 },
            { id: "2", x: 305, y: 136, width: 215, height: 143, rotation: 0, imageRotation: 0 },
            { id: "3", x: 305, y: 287, width: 215, height: 143, rotation: 0, imageRotation: 0 },
            { id: "4", x: 305, y: 438, width: 215, height: 143, rotation: 0, imageRotation: 0 },
            { id: "5", x: 528, y: 136, width: 297, height: 446, rotation: 0, imageRotation: 0 },
            { id: "6", x: 833, y: 136, width: 296, height: 446, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1137, y: 136, width: 296, height: 446, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-07-h3v4-10",
        name: "SQ 10 - H3V4",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-07-h3_v4_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 136, width: 297, height: 446, rotation: 0, imageRotation: 0 },
            { id: "2", x: 305, y: 136, width: 297, height: 446, rotation: 0, imageRotation: 0 },
            { id: "3", x: 610, y: 136, width: 296, height: 446, rotation: 0, imageRotation: 0 },
            { id: "4", x: 914, y: 136, width: 296, height: 446, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1218, y: 136, width: 215, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1218, y: 288, width: 215, height: 143, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1218, y: 439, width: 215, height: 143, rotation: 0, imageRotation: 0 }
        ],
    },
];
